/**
 * Flag global para ativar dados mock em desenvolvimento.
 * Defina REACT_APP_USE_MOCK=true no .env.development para usar.
 */
export const USE_MOCK = process.env.REACT_APP_USE_MOCK === 'true';
